import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M12 12V0C5.373 0 0 5.373 0 12z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "m9.612 7.826.194.598h.629l-.509.37.194.597-.508-.37-.509.37.195-.598-.509-.369h.629zM6.454 3.131l.323.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615H6.13zM9.586 4.175l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.323-.997-.847-.615h1.047zM7.11 8.349l.324.996H8.48l-.847.616.323.997-.847-.616-.848.616.324-.997-.848-.616h1.048zM4.368 5.74l.323.996H5.74l-.848.616.324.996-.847-.615-.848.615.324-.996-.848-.616h1.048z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }